import { encode as base64_encode } from "base-64";
import { postApi } from "../components/Utility";
import config from "../config";
import { action, makeObservable, observable } from "mobx";
import { getCached, setCached, invalidateCache } from "./cacheStore";

class UsersStore {
  users = [];
  getDeviceGroupsUsingCompanyId = [];
  getVehiclesUsingCompanyId = [];
  groupVehicles = [];
  searchVehicles = [];
  assignvehicles = [];
  devicegroupId = [];

  beforeEditCompanyNo = "";

  total = 0;
  loading = false;

  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      users: observable,
      beforeEditCompanyNo: observable,
      getDeviceGroupsUsingCompanyId: observable,
      getVehiclesUsingCompanyId: observable,
      groupVehicles: observable,
      total: observable,
      loading: observable,
      searchVehicles: observable,
      assignvehicles: observable,
      devicegroupId: observable,

      loadData: action,
      addData: action,
      getUserData: action,
      sendEmail: action,
      exportExcel: action,
      beforeEditCompanyId: action,
      setPhotoFromDb: action,

      getDeviceGroups: action,
      getVehiclesData: action,
      getGroupVehicles: action,
      searchVehicle: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({
    offset,
    limit,
    companyId,
    searchField,
    userType,
    userStatus,
    isadmin,
    userId,
  }) {

    var postData = {
      companyId: companyId,
      offset: offset,
      limit: limit,
      searchField: searchField,
      userType: userType,
      userStatus: userStatus,
      isadmin: isadmin,
      userId: userId,
    };
    const cacheKey = `userList:${offset}:${limit}:${companyId}:${searchField}:${userType}:${userStatus}:${isadmin}:${userId}`;
    console.log(cacheKey)
    const cached = getCached(cacheKey);
    console.log(cached);

    if (cached) {
      this.users = cached.users;
      this.total = cached.total;
      return;
    }
    this.loading = true;

    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=user&a=getuserList", "postData=" + base64Input);

    const response = await postApi
      .getClient()
      .get(config.NodeUrl + "/users/get-users", {
        params: postData,
      });

    let users;
    let total;
    if (response?.data?.data === null) {
      users = [];
    } else {
      users = await response?.data?.usersData;
    }

    total = parseInt(response?.data?.TotalCount);

    setCached(cacheKey, { users, total });

    this.users = users;
    this.total = total;
    this.loading = false;


  }
  async setPhotoFromDb(photo) {
    this.photoFromDb = { fileList: photo };
  }

  async addData(user) {
    var postData = { tokenId: "80bovn8u800tg1aq9bvr73kbhh", user };

    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=user&a=update", "postData=" + base64Input);

    var userData = { user };
    var response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/users/saveUser", userData);

    invalidateCache('userList');

    return response;
  }

  async getUserData(userId) {
    var postData = { userId: userId, limit: 1, offset: 0 };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=user&a=getuserList", "postData=" + base64Input);
    // //  console.log(response)
    // var singleRow = response.data.data.users[0];

    const params = { userId, limit: 1, offset: 0 };
    const response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/users/get-users", {
        params: params,
      });
    var singleRow = response.data?.usersData[0];

    if (singleRow.photo && singleRow.isadmin === 2) {
      const fileList = [
        {
          name: singleRow.photo,
          status: "success",
          url: config.fleetURL + "/images/drivers/" + singleRow.photo,
        },
      ];

      this.setPhotoFromDb(fileList);
    } else if (singleRow.photo && singleRow.isadmin === 5) {
      const fileList = [
        {
          name: singleRow.photo,
          status: "success",
          url: config.fleetURL + "/images/salesperson/" + singleRow.photo,
        },
      ];

      this.setPhotoFromDb(fileList);
    } else if (singleRow.photo) {
      const fileList = [
        {
          name: singleRow.photo,
          status: "success",
          url: config.fleetURL + "/images/users/" + singleRow.photo,
        },
      ];

      this.setPhotoFromDb(fileList);
    }

    return singleRow;
  }

  async deleteRecord({ userId }) {
    var postData = { user: { userId: userId } };

    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=user&a=delete", "postData=" + base64Input);

    var response = await postApi
      .getClient("")
      .delete(config.NodeUrl + "/users/deleteUser", {
        params: {
          id: userId,
        },
      });
    invalidateCache('userList');
    return response;
  }

  async sendEmail({ emailId, username, password }) {
    this.loading = true;
    var postData = { emailId: emailId, username: username, password: password };

    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=user&a=sendUserDetails", "postData=" + base64Input);
    this.loading = false;

    return response;
  }

  async beforeEditCompanyId(value) {
    this.beforeEditCompanyNo = value;
  }
  //For Assign vehicle to user
  async getDeviceGroups({ companyId }) {
    const postData = { companyId: companyId, offset: 0, limit: 100, page: 1 };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=company&a=getDeviceGroups", "postData=" + base64Input);

    this.getDeviceGroupsUsingCompanyId = response?.data?.data?.devicegroups;

    return response?.data?.data?.devicegroups;
  }
  //For Assign vehicle to user
  async getGroupVehicles({ groupNameId }) {
    const postData = { groupNameId: groupNameId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=company&a=getGroupVehicles",
        "postData=" + base64Input
      );

    this.groupVehicles = response?.data?.data?.getDeviceGroupsVehicles;

    this.searchVehicles = response?.data?.data?.getDeviceGroupsVehicles;
    return response?.data?.data?.getDeviceGroupsVehicles;
  }
  //For Assign vehicle to user
  async getVehiclesData({ companyId, userId }) {
    const postData = {
      ruleId: "",
      companyId: companyId,
      userId: userId,
      isadmin: -1,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=vehicle&a=getAllUserVehicles",
        "postData=" + base64Input
      );

    this.getVehiclesUsingCompanyId = response?.data?.data?.Vehicles;
    this.assignvehicles = response?.data?.data?.assignvehicles;
    this.devicegroupId = response?.data?.data?.devicegroupId;

    this.total = parseInt(response?.data?.data?.TotalCount);
    return response?.data?.data?.Vehicles;
  }

  async searchVehicle({ userId, companyId, text }) {
    this.loading = true;
    var postData = {
      companyId: companyId,
      userId: userId,
      isadmin: -1,
      text: text,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=vehicle&a=searchVehicleUser",
        "postData=" + base64Input
      );
    this.searchVehicles = await response?.data?.data;

    return await response?.data?.data;
  }

  async updateStatus(data) {
    // var postData = data;
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=user&a=updateActive", "postData=" + base64Input);
    // return response.data;

    var activeStatus = data.activeStatus;
    var userId = data.userId;
    var response = await postApi
      .getClient("")
      .patch(
        config.NodeUrl + "/users/updateStatus",
        { status: activeStatus },
        { params: { userId } }
      );
    invalidateCache('userList');
    return response.data;
  }

  // async exportExcel(getData) {
  //   console.log("getData", getData);
  //   window.location.href =
  //     baseURL +
  //     "index.php?c=user&a=exportUsersExcel&cid=" +
  //     getData.companyId +
  //     "&searchField=" +
  //     getData.searchField +
  //     "&colList=" +
  //     getData.colList;
  // }

  async exportExcel(postData) {
    try {
      var response = await postApi
        .getClient("")
        .post(config.NodeUrl + "/users/exportUserExcel", postData, {
          responseType: "blob",
        });

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "User Report.xlsx";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file", error);
    }
  }
  async logout(userId) {
    var postData = { userId: userId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=user&a=logout", "postData=" + base64Input);
    return response.data;
  }

  async otpsubmit(values) {
    const postdata = values
    console.log("This is the onsubmit postdata", postdata)
    var response = await postApi
      .getClient()
      .post(config.NodeUrl + "/users/setOtpAdmin", postdata);
    return response;
  }

  async skipbutton(postData) {

    console.log("This is the onskipbutton postdata", postData)
    const response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/users/updateLoginCount", postData);
    return response;

  }

  async resendOtp(postData) {
    console.log("resendOtp postData", postData);
    const response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/users/setOtpAdmin", postData);
    return response;
  }

  async validateotp(postData) {
    console.log("XXXXXXXXXXXXXXX", postData);
    const response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/users/verifyAdminOtp", postData);
    return response?.data;
  }

  async sendverificationotp(postData) {
    console.log("sendverificationotp", postData);
    const response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/users/sendOtp", postData);
    return response;
  }

  async verifymobileadminotp(postData) {
    console.log("This the main data given by the distri", postData);
    const response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/users/verifyMobileOtp", postData);
    return response;

  }
  async adminresendoptlogin(postData) {
    console.log("object", postData);
    const response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/users/sendOtp", postData);
    return response;

  }

  async saveuserdetails(postData) {
    console.log("saveuserdetails", postData);
    const response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/users/saveAdminData", postData);
    return response;
  }

}

export default UsersStore;
